// extracted by mini-css-extract-plugin
module.exports = {"actions":"LenderActions_actions__1sNjU","menu":"LenderActions_menu__wP3Ej","reassign":"LenderActions_reassign__THRGi"};